module.exports = __webpack_public_path__ + "static/9-4858aadedd81a1d92174175edcd57683.mp4";